import { UserLoginModel } from '@max/shared/models/business-transaction/user-login.model';
import { createAction, props } from '@ngrx/store';

export const loadUsersSuccess = createAction(
    '[Transaction API] Load Success',
    props<{ users: UserLoginModel[] }>()
);

export const loadUsersFailure = createAction(
    '[Transaction API] Load Failure',
    props<{ error: string }>()
);
